// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";


// Stateful components

export class AskUs extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
        };

    }

    componentDidMount() {
        var this_component = this;
        this_component.processFaqs();
    }


    //
    // Functions
    //

    processFaqs() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];

        var faqs = this_component.getCurrentFaqs();
        if (faqs) {
            var faq_list = faqs['list'];
            var count = faqs['max_count'];
            var filtered_faqs = [];
            
            if (faq_list) {
                filtered_faqs = sq_personalise.fn.filterItems(faq_list, user_personalisation['attributes']);
            }

            if (filtered_faqs.length > 0) {
                this_component.getFaqContent(filtered_faqs[0], count);
            }
        }
        

    }

    getCurrentFaqs() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var current_page = portal_context['current_page'];
        var current_page_data = helpers.getPageBySlug(current_page);
        var ia_level = current_page_data['ia_level'];

        var page_data = null;

        if (ia_level === 1) {
            page_data = current_page_data;
        } else {
            var parent_page = current_page_data['parent'];
            page_data = helpers.getPageBySlug(parent_page);
        }

        if (page_data) {
            if (typeof page_data['content'] !== 'undefined' && typeof page_data['content']['faqs'] !== 'undefined'){
                return page_data['content']['faqs'];
            }
        }
        return null;
    }

    getFaqContent(faq, count) {
        
        if (faq) {
            if (typeof RightNow !== 'undefined' && typeof RightNow.Client.Controller.addComponent == 'function') {
                RightNow.Client.Controller.addComponent({
                    description: false,
                    div_id: "faq-data-target",
                    label_more_results: "More FAQs",
                    navigation: false,
                    q: faq['query'],
                    recommended: false,
                    related: false,
                    search_box: false,
                    instance_id: "skw_0",
                    module: "KnowledgeSyndication",
                    number_answers: count,
                    type: 3
                },'https://griffithstudenthelp.widget.custhelp.com/ci/ws/get');


                // Find and remove any data added to the body instead of the Ask Us component
                var body = document.querySelector('body');

                var config = {
                    attributes: true,
                    childList: true
                };
                
                var callback = function(mutations_list, observer) {
                    
                    for (var i in mutations_list) {
                        var mutation = mutations_list[i];
                        
                        if (mutation.addedNodes.length > 0) {
                            
                            if (mutation.addedNodes[0].getAttribute('id') === 'faq-data-target') {
                                
                                var data_target = document.getElementById('faq-data-target');
                                
                                if (data_target !== null) {
                                    data_target.parentNode.removeChild(data_target);                            
                                }
                            }
                        }
                    }
                };

                var observer = new MutationObserver(callback);

                observer.observe(body, config);
                setTimeout(function() {
                    observer.disconnect();
                }, 1000);
            }

        }
    
    }

    cleanPage() {
        var iframe = document.querySelector('body > iframe[title="Action Capture"]');
        if (iframe !== null) {
            iframe.parentNode.removeChild(iframe);
        }
    }
   


    //
    // Render
    //


    render() {
        var this_component = this;
        this_component.cleanPage();

        return (
            <div className="ask-us__wrapper" data-ga-label="Ask us">
                <h2 className="link-block__title">Ask us - Frequently asked questions</h2>
                <ContextualMessage id="ask_us" />
                <div id="faq-data-target"></div>
            </div>  
        );
    }

};

AskUs.contextType = PortalContext;
